import { addTitleAndGoalToAbTest } from "../../helpers";
import DeleteConfirmModal from "../reusables/DeleteConfirmModal/DeleteConfirmModal";
import "./AbTestStyles.css";
import AbTestDataBox from "./AbTestDataBox";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import CustomInput from "../CustomInput/CustomInput";
import { toast } from "react-toastify";

const AbTestStep4 = ({
  selectedTest,
  finishAbTest,
  weeklySessions,
  hasWeekOfData,
  bSessions,
  goals,
}) => {
  const navigate = useNavigate();
  const [estimate, setEstimate] = useState(0);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);

  useEffect(() => {
    if (!weeklySessions || !selectedTest.percentage) return;
    const estimate =
      2000 / (weeklySessions / 7) / (selectedTest?.percentage / 100);
    const remainingDays = bSessions
      ? estimate * (1 - bSessions / 2000)
      : estimate;
    setEstimate(Math.round(remainingDays));
  }, [weeklySessions]);

  const goal = goals.find((goal) => goal.id === selectedTest.goalId);
  const bTraffic = selectedTest.percentage;
  const aTraffic = 100 - bTraffic;

  const [newTitle, setNewTitle] = useState(selectedTest.title);
  const [newGoal, setNewGoal] = useState({ label: goal.label, value: goal.id });
  const [goalsDropdownOpen, setGoalsDropdownOpen] = useState(false);

  return (
    <div>
      <div className="abtest-info-block mb-50">
        {selectedTest?.status === "done" ? (
          <>
            <i className="mr-8 fa-light fa-fire-flame-curved"></i> Your test is
            complete.
          </>
        ) : (
          <>
            <i className="mr-8 fa-light fa-hourglass-clock"></i> Your test is
            running.
          </>
        )}
      </div>
      <div className="abtest-w367 mb-100">
        <AbTestDataBox
          header="Entries collected"
          content={`${bSessions ?? 0} / 2000`}
          type="grey"
          className="mb-16"
        />

        {hasWeekOfData ? (
          <div className="fw-500 fc-grey fs-16 mb-50">
            Your report will be{" "}
            <span className="fw-700 underline">
              ready in around {estimate} days.
            </span>
          </div>
        ) : (
          <div>
            Not enough traffic to provide an estimate. Check back later!
          </div>
        )}

        <div className="fw-700 fs-18 fc-black mb-16">Test setup</div>
        <div className="mb-10">
          <CustomInput
            minWidth="100%"
            type="text"
            placeholder={"Name of your test"}
            onChange={(e) => setNewTitle(e.target.value)}
            valueState={newTitle}
          />
        </div>

        <div className="no-margins-or-padding mb-10">
          <div>
            <CustomDropdown
              unstyled
              placeholder="Goal"
              options={goals.map((goal) => ({
                label: goal.label,
                value: goal.id,
              }))}
              onChange={(e) => {
                setNewGoal(e);
              }}
              value={newGoal}
              menuOpenState={goalsDropdownOpen}
              setMenuOpenState={setGoalsDropdownOpen}
            />
          </div>
        </div>

        <AbTestDataBox
          header="Target goal"
          content={goal?.label ?? "N/A"}
          type="grey"
          className="mb-10"
        />
        <AbTestDataBox
          header="Traffic on the current version (A)"
          content={`${aTraffic}%`}
          type="grey"
          className="mb-10"
        />
        <AbTestDataBox
          header="Traffic on the current version (B)"
          content={`${bTraffic}%`}
          type="grey"
          className="mb-20"
        />
        <div className="space-between">
          <button
            onClick={() => {
              addTitleAndGoalToAbTest(
                selectedTest?.id,
                newTitle,
                newGoal.value,
              ).then((res) => {
                if (res) {
                  toast.success("Test updated successfully!");
                  navigate("/ab-test");
                } else {
                  toast.error("Test could not be updated.");
                }
              });
            }}
            className="btn-primary fw-700"
          >
            Update the test
          </button>

          {selectedTest?.status === "in-progress" && (
            <button
              onClick={() => {
                setDeleteConfirmModalOpen(true);
              }}
              className="btn-nonary"
            >
              Cancel the test
            </button>
          )}
        </div>
      </div>
      <DeleteConfirmModal
        isOpen={deleteConfirmModalOpen}
        onRequestClose={() => setDeleteConfirmModalOpen(false)}
        text="Are you sure you want to finish this test?"
        onDelete={async () => finishAbTest(selectedTest)}
        onCancel={() => setDeleteConfirmModalOpen(false)}
      />
    </div>
  );
};

export default AbTestStep4;
